import HideImageIcon from '@mui/icons-material/HideImage';
import ImageIcon from '@mui/icons-material/Image';
import { Button, ImageList } from '@mui/material';
import { lang, naturalSort } from 'src/utils';
import { getThumbnailSrc } from 'src/utils/gcf-helper';

import { findMatchedAsset } from '../ResourceSelector.helper';
import { ResourceSelectorContainer } from '../resourceSelectorSidebarWidget/ResourceSelectorSidebar.styled';
import { ResourceSelectorSidebarHeader } from '../resourceSelectorSidebarWidget/resourceSelectorSidebarHeader';
import { ResourceSelectorSidebarItem } from '../resourceSelectorSidebarWidget/resourceSelectorSidebarItem';
import { AssetsFlavorGroup } from './modules/assetsFlavorGroup/AssetsFlavorGroup';
import { Content } from './ThemeAssetsSelectorDrawer.styled';

interface AssetSelectionContentProps {
  assets: any[];
  product: any;
  props: any;
  refetchAssets: () => void;
}

export const AssetSelectionContent = ({
  assets,
  product,
  props,
  refetchAssets,
}: AssetSelectionContentProps) => {
  const groupAsset = findMatchedAsset(
    assets,
    undefined,
    product?.assets?.[0]?.name,
  );

  const sortedProductVariations = naturalSort(
    product?.productVariations ?? [],
    'productVariationFlavor.name',
  );

  return (
    <ResourceSelectorContainer>
      <ResourceSelectorSidebarHeader
        label={props.label || ''}
        onBackClick={props.onCloseModal}
        rightElement={
          props.enableUploadProductImages && (
            <Button
              variant="outlined"
              component="label"
              startIcon={<ImageIcon />}
              onClick={props.onRightButtonClick}>
              {lang.selectMore}
            </Button>
          )
        }
        refetchAssets={refetchAssets}
      />
      <Content>
        <ImageList cols={3} rowHeight={120}>
          <ResourceSelectorSidebarItem
            isSelected={false}
            fileName={lang.groupImage}
            src={
              groupAsset?.thumbnailUrl ||
              getThumbnailSrc(product?.assets?.[0]?.name)
            }
            onClick={() =>
              props.handleAssetChange(
                product?.assets?.[0]?.name ?? '',
                product.product_code,
              )
            }
          />

          <ResourceSelectorSidebarItem
            isSelected={false}
            fileName={lang.noImage}
            icon={<HideImageIcon color="action" fontSize="medium" />}
            src=""
            onClick={() => props.handleAssetChange(null, product.product_code)}
          />
        </ImageList>

        {sortedProductVariations.map((productVariation: any) => {
          const label = `${
            productVariation.productVariationSize?.name || 'None'
          } ${productVariation.productVariationFlavor?.name || 'None'}`;

          return (
            <AssetsFlavorGroup
              key={productVariation.product_code}
              label={label}
              productVariation={productVariation}
              handleAssetChange={(ccAsset, productVariationCode) =>
                props.handleAssetChange(ccAsset.name, productVariationCode)
              }
              enableUploadProductImages={props.enableUploadProductImages}
            />
          );
        })}
      </Content>
    </ResourceSelectorContainer>
  );
};
